'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAction = undefined;

var _params = require('../params');

var defaultFetch = function defaultFetch(type, params) {
  return {
    type: type,
    payload: { params: params }
  };
};

var defaultFetchSuccess = function defaultFetchSuccess(type, data) {
  return {
    type: type,
    payload: { data: data }
  };
};

var defaultFetchFailure = function defaultFetchFailure(type, error) {
  return {
    type: type,
    payload: { error: error }
  };
};

var createAction = exports.createAction = function createAction(_ref) {
  var _ref$fetcher = _ref.fetcher,
      fetcher = _ref$fetcher === undefined ? (0, _params.required)() : _ref$fetcher,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === undefined ? (0, _params.required)() : _ref$namespace,
      _ref$actionDispatcher = _ref.actionDispatchers,
      actionDispatchers = _ref$actionDispatcher === undefined ? {} : _ref$actionDispatcher;
  return function (dispatch) {
    var c = {
      FETCH: namespace + '/FETCH',
      FETCH_SUCCESS: namespace + '/FETCH_SUCCESS',
      FETCH_FAILURE: namespace + '/FETCH_FAILURE'
    };

    var _actionDispatchers$fe = actionDispatchers.fetch,
        fetch = _actionDispatchers$fe === undefined ? defaultFetch : _actionDispatchers$fe,
        _actionDispatchers$fe2 = actionDispatchers.fetchSuccess,
        fetchSuccess = _actionDispatchers$fe2 === undefined ? defaultFetchSuccess : _actionDispatchers$fe2,
        _actionDispatchers$fe3 = actionDispatchers.fetchFailure,
        fetchFailure = _actionDispatchers$fe3 === undefined ? defaultFetchFailure : _actionDispatchers$fe3;


    dispatch(fetch(c.FETCH));

    return fetcher.then(function (data) {
      dispatch(fetchSuccess(c.FETCH_SUCCESS, data));
      return Promise.resolve(data);
    }).catch(function (error) {
      dispatch(fetchFailure(c.FETCH_FAILURE, error));
      return Promise.reject(error);
    });
  };
};